import clone from 'lodash/cloneDeep';
import initialState from '../../../store/initialState';
import {
  ACTIVATE_BUTT_JOINT_CONNECTION_STARTING,
  ACTIVATE_BUTT_JOINT_CONNECTION_SUCCESS,
  ACTIVATE_BUTT_JOINT_CONNECTION_ERROR,
} from '../../../constants/actionTypes';

export default function activateButtJointReducer(state = initialState.activateButtJoint, action) {
  switch (action.type) {
    case ACTIVATE_BUTT_JOINT_CONNECTION_STARTING: {
      const { buttJointId } = action;
      const newState = clone(state);

      if (!newState[buttJointId]) {
        newState[buttJointId] = clone(initialState.activateButtJoint.buttJointId);
      }

      const buttJointData = newState[buttJointId];
      buttJointData.saving = true;
      buttJointData.saved = false;
      buttJointData.error = null;

      return newState;
    }

    case ACTIVATE_BUTT_JOINT_CONNECTION_SUCCESS: {
      const { buttJointId } = action;
      const newState = clone(state);

      if (!newState[buttJointId]) {
        newState[buttJointId] = clone(initialState.activateButtJoint.buttJointId);
      }

      const buttJointData = newState[buttJointId];
      buttJointData.saving = false;
      buttJointData.saved = true;
      buttJointData.error = null;
      return newState;
    }

    case ACTIVATE_BUTT_JOINT_CONNECTION_ERROR: {
      const { buttJointId } = action;
      const newState = clone(state);

      if (!newState[buttJointId]) {
        newState[buttJointId] = clone(initialState.activateButtJoint.buttJointId);
      }

      const buttJointData = newState[buttJointId];
      buttJointData.saving = false;
      buttJointData.saved = false;
      buttJointData.error = action.err;
      return newState;
    }

    default: {
      return state;
    }
  }
}
